import React from 'react'
import { OfferPageRoom } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import OfferDesktopFlightToggle from '../Filters/FlightToggle/OfferDesktopFlightToggle'
import useBedbankFlightPrice from 'hooks/OfferPage/useBedbankFlightPrice'

interface Props {
  offer: App.BedbankOffer
  rooms: Array<OfferPageRoom>
  checkInDate?: string
  checkOutDate?: string
  airport?: App.Airport
}

function BedbankDesktopFlightToggle({
  offer,
  rooms,
  checkInDate,
  checkOutDate,
  airport,
}: Props) {
  const flightPrice = useBedbankFlightPrice(offer, {
    rooms,
    startDate: checkInDate,
    endDate: checkOutDate,
    originAirportCode: airport?.code,
  })

  return <OfferDesktopFlightToggle totalFlightPrice={flightPrice} />
}

type MappedProps = Pick<Props,
  | 'offer'
  | 'rooms'
  | 'checkInDate'
  | 'checkOutDate'
  | 'airport'
>

export default withOfferPageState((offerState): MappedProps => ({
  airport: offerState.airport,
  offer: offerState.bedbankOffer!,
  rooms: offerState.rooms,
  checkInDate: offerState.checkInDate,
  checkOutDate: offerState.checkOutDate,
}), BedbankDesktopFlightToggle)
